import * as React from "react";
import { Typography, Box, TextField, Button } from "@mui/material";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { styled } from "@mui/material/styles";
import { useTranslation } from "react-i18next";
import dayjs from "dayjs";
import 'dayjs/locale/fr';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import updateLocale from 'dayjs/plugin/updateLocale';

// Extend dayjs with plugins
dayjs.extend(localizedFormat);
dayjs.extend(updateLocale);
const Content = styled(Typography)`
  margin-bottom: 0.3rem;
`;

export default function CalendarPicker({
  input,
  required,
  label,
  value,
  onChange,
  disabled,
  inputVal,
  monthYear,
  errorMessage,
  error,
  meta,
  formatDate,
  ...props
}) {
  const [selectedVal, setselectedVal] = React.useState();
  const { t, i18n } = useTranslation();
  const selectedLanguage = localStorage.getItem("selectedLanguage");
  React.useEffect(() => {
    if (selectedLanguage === 'fr') {
      dayjs.locale('fr');
      dayjs.updateLocale('fr', {
        months: [
          "janvier", "février", "mars", "avril", "mai", "juin",
          "juillet", "août", "septembre", "octobre", "novembre", "décembre"
        ]
      });
    } else {
      dayjs.locale('en');
    }
  }, [selectedLanguage]);
  const handleChange = (newValue) => {
    let parsedDate;
    if (monthYear && newValue) {
      // If monthYear is enabled and a valid value is selected
      parsedDate = dayjs(newValue).startOf("month"); // Set to the first day of the month
    } else {
      parsedDate = dayjs(newValue);
    }
    // Format the parsedDate into the desired format "YYYY-MM-DD"
    const formattedDate = parsedDate.format("YYYY-MM-DD");
    setselectedVal(formattedDate);
    onChange(formattedDate);
  };
  const inputStyle = {
    height: "10px", // Adjust the height as needed
    fontSize: "0.875rem", // Adjust the font size as needed
    padding: "6px 8px", // Adjust the padding as needed
  };

  React.useEffect(() => {
    setselectedVal(inputVal);
  }, [inputVal]);

  return (
    <>
      <Content>
        <Typography required={required} color="#666666">
          {t(label)}
        </Typography>
      </Content>
      <Box
        component="form"
        sx={{

          "& .MuiOutlinedInput-root": { height: "2.4rem" },
          "& .MuiTextField-root": { width: "100%" },

        }}
        noValidate
        autoComplete="off"
      >
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <DatePicker
            value={
              inputVal
                ? dayjs(inputVal)
                : selectedVal
                  ? dayjs(selectedVal)
                  : null
            }
            maxDate={dayjs()}
            format={!!formatDate ? formatDate : "YYYY-MM-DD"}
            onChange={handleChange}
            views={monthYear && ["month", "year"]}
            disabled={disabled}
            slotProps={{
              actionBar: {
                actions: [t("clear")],
                render: ({ actions }) => (
                  <>
                    {actions}

                    <Button onClick={() => onChange(inputVal)}>OK</Button>
                    {/* <Button onClick={handleClose}>Cancel</Button> */}
                  </>
                ),
              },
            }}
            renderInput={(params) => (
              <TextField
                size="small"
                onChange={(e) => handleChange(e.target.value)}
                {...params}
                style={inputStyle} // Apply inline styles here
                // error={error} // Pass error prop to TextField
                error={meta && meta.touched && meta.error && error}

                helperText={errorMessage}
              />
            )}
          />
          {errorMessage ? (
            <Typography color="red" fontSize={".8rem"} align={"center"}>
              {t(errorMessage)}
            </Typography>
          ) : (
            ""
          )}
        </LocalizationProvider>
      </Box>
    </>
  );
}
